<template>
<div>
  <div class="hello-text container">
    <h2>Let´s work together!</h2>
    <h3>Feel free to contact me.</h3>
    <div class="separator"></div>
    <div class="contact-info">
      <h3><email-icon></email-icon><a href="mailto:hello@jonnanarhi.com">hello@jonnanarhi.com</a></h3>
      <h3><a href="https://www.instagram.com/narhijonna/"><img class="insta-logo" width="18px" height="18px" src="@/assets/glyph-logo_May2016.png">instagram.com/narhijonna</a></h3>
    </div>
  </div>  
</div>
</template>

<script>
import EmailIcon from 'vue-material-design-icons/Email.vue';
import { SettingsService, LoggingService } from '@/services/ApiService';

export default {
  name: "SayHello",
  components: {
    EmailIcon
  },
  data() {
    return {
      siteSettings: {
        bannerUrl: ""
      }      
    }
  },
  created: function () {
    this.loadSettings();
    const root = document.documentElement;
    root.style.setProperty('--body-bg', '#ffffff');    
  },  
  computed: {
    heroBannerUrl: function () {
      return "background-image: url(" + this.siteSettings.bannerUrl + ")";
    }
  },
  methods: {
    loadSettings() {
      SettingsService.get().then(res => {
        this.siteSettings = res.data[0];
      }).catch(err => {
        LoggingService.log("Home", "Error loading SiteSettings", err);
      });
    },    
  }
}
</script>

<style lang="less" scoped>
.separator {
    height: 4px;
    width: 20px;
    background-color: var(--accent);
    text-align: center;
    margin: 0 auto;
    margin-top: 40px;
}
.email-icon, .insta-logo {
  margin-right: 5px;
}
.hello-text {
  margin-top: 60px;
  h2, h3 {
    text-transform: none !important;
  }
}
.contact-info {
  margin-top: 40px;
}
</style>
